import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';

import SubPaymentMethodsSideComponent from '../../components/PaymentMethods/SubPaymentMethodsSideComponent';

import { selectClient } from '../../global-selectors';
import { requestAsync } from '../../queries/actions';
import { getSubPaymentMethods } from '../../queries/payment';
import { selectUserData } from '../../queries/selectors/user';
import { getSelectedPlan } from '../../queries/selectors/shoppingCart';
import { setCurrentSubPaymentMethod } from '../../queries/actions/payment';
import { selectSingleSubscriptionClient } from '../../queries/selectors/bootstrap';
import { selectCurrentPaymentMethod, selectSubPaymentConfig } from '../../queries/selectors/payment';

const mapStateToProps = (state) => ({
  client: selectClient(state),
  subPaymentMethods: selectSubPaymentConfig(state),
  paymentMethod: selectCurrentPaymentMethod(state),
  planSelected: getSelectedPlan(state),
  userData: selectUserData(state),
  isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
});

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    getSubPaymentMethods: payload => requestAsync(getSubPaymentMethods, payload),
    setCurrentSubPaymentMethod: payload => dispatch(setCurrentSubPaymentMethod(payload)),
  }, dispatch)
);

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(SubPaymentMethodsSideComponent);
